<template>
  <b-modal size="sm" id="ModalAtalhos" hide-footer>
    <Header titulo="TECLAS DE ATALHO" cor="azul" :close="cancelar" slot="modal-header" />
    <div class="modal-atalhos-corpo">
      <h5>Formulário:</h5>
      <p><b>Ctrl + Enter:</b> Carregar resultado.</p>
      <p><b>Ctrl + S:</b> Salvar cenário.</p>
      <p><b>Ctrl + Backspace:</b> Limpar cenário.</p>
      <p><b>Ctrl + Espaço:</b> Abrir a tela de cenários salvos.</p>
      <h5>Carregar Cenário:</h5>
      <p><b>Enter:</b> Carregar cenário.</p>
      <p><b>Seta para direita:</b> Seleciona próximo card.</p>
      <p><b>Seta para esquerda:</b> Seleciona card anterior.</p>
      <p><b>Seta para cima:</b> Próxima página.</p>
      <p><b>Seta para baixo:</b> Página anterior.</p>
    </div>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

export default {
  name: "ModalAtalhos",
  components: {
    BotaoPadrao,
    Header
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  methods: {
    handleKey(event) {
      let modal = document.getElementById("ModalAtalhos");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.limpaDadosForm();
          this.$root.$emit("bv::hide::modal", "ModalAtalhos");
        }
      }
    },
    handleClick() {
      this.limpaDadosForm();
      this.$root.$emit("bv::hide::modal", "ModalAtalhos");
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalAtalhos");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-atalhos-corpo {
  h5 {
    margin: 10px 0;
    font-family: "Roboto Condensed";
    font-weight: bold;
    &:first-child {
      margin-top: 0;
    }
  }
  p {
    margin-bottom: 5px;
  }
}
</style>
